var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"wd-100p",style:(("height: " + (_vm.getScrollHeight()) + " border: 0")),attrs:{"src":_vm.task.taskEn,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }